"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _CTBYSXNUcjs = require('../__chunks/CTBYSXNU.cjs');


var _XXF5DFSGcjs = require('../__chunks/XXF5DFSG.cjs');
require('../__chunks/5OZ7J4C2.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-button-arrow.tsx
var TagName = "span";
var useMenuButtonArrow = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuButtonArrow2({ store, ...props }) {
    const context = _XXF5DFSGcjs.useMenuContext.call(void 0, );
    store = store || context;
    props = _CTBYSXNUcjs.usePopoverDisclosureArrow.call(void 0, { store, ...props });
    return props;
  }
);
var MenuButtonArrow = _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuButtonArrow2(props) {
  const htmlProps = useMenuButtonArrow(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.MenuButtonArrow = MenuButtonArrow; exports.useMenuButtonArrow = useMenuButtonArrow;
